module.exports = __webpack_public_path__ + "static/media/brand-logo-black.2c2a7ac7.svg";